export interface Location {
  id?: number;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  stateCode: string;
  stateName?: string;
  zipCode: string;
  countryCode?: string;
  latitude?: number;
  longitude?: number;
  geocodingStatus?: string;
  geocodingError?: string;
  fullAddress?: string;
}
